<template>
  <!-- 会员福利社详情 -->
  <div class="vipCoupon">
    <publicHeader
      :pageTitle="pageTitle"
      isWhite="true"
      :urlhandle="urlhandle"
    ></publicHeader>
    <div class="zhanwei"></div>
    <div class="couponMain">
      <div class="info" v-if="info.discount">
        <div class="couponName">
          <span class="rmb">￥</span>{{ info.discount.high
          }}<span class="word">优惠券</span>
        </div>
        <div class="couponType">{{ info.discount.mj }}</div>
      </div>
      <div class="btn">
        <div class="redbtn" @click="getReceiveCoupon()" v-if="!info.status">
          立即领取
        </div>
        <div class="redbtn gbtn" v-else>已领取</div>
      </div>
    </div>
    <div class="other">
      <div class="otherItem" v-for="(item, index) in other" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="content">
          <div
            class="contentItem"
            v-for="(value, index2) in item.content"
            :key="index2"
          >
            {{ value }}
          </div>
        </div>
      </div>
    </div>
    <publicDialog
      :info="infos"
      :title="title"
      :btn1="btn1"
      :btn2="btn2"
      @changeShow="showDialog"
      :dialogIsShow="dialogIsShow"
      v-show="dialogIsShow"
    ></publicDialog>
    <publicCouponDialog
      v-if="showCouponDialog"
      :vipCouponDialogInfo="vipCouponDialogInfo"
      :showCouponDialog="showCouponDialog"
      @changeCouponDialog="changeCouponDialog"
      @handleOpenVip="handleOpenVip"
    ></publicCouponDialog>
  </div>
</template>

<script>
import publicDialog from '../components/PublicDialog'
import publicHeader from '../components/PublicHeader'
import publicCouponDialog from '../components/publicCouponDialog.vue'
export default {
  components: {
    publicDialog,
    publicHeader,
    publicCouponDialog
  },
  data() {
    return {
      actId: '',
      info: '',
      other: '',
      // dialog的提示内容
      dialogIsShow: false,
      infos: '',
      title: '提示',
      btn1: '',
      btn2: '我知道了',
      isIOS: false,
      pageTitle: '',
      token: '',
      urlhandle: '',
      vipCouponDialogInfo: '',
      showCouponDialog: false
    }
  },
  created() {
    this.getToken()
    document.title = '会员福利社'
    this.pageTitle = '会员福利社'
    this.changeAppTitle('会员福利社')
    this.isIOS = this.$CONFIG.isIOS
    this.actId = this.$route.query.id
    this.getCouponDetail()
  },
  beforeRouteEnter(to, from, next) {
    console.log(to.name ,from.name)
    if (to.name === 'vipcoupon' && from.name === 'vipWelfare') {
      next((vm) => {
        console.log(vm)
        vm.urlhandle = 'back'
      })
    }
    next()
  },
  methods: {
    // 获取url上的信息
    getcommit(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || ['', ''])[1].replace(/\+/g, '%20')
        ) || false
      )
    },
    // 获取token
    getToken() {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token)
    },
    async getCouponDetail() {
      let params = {
        token: this.token,
        actId: this.actId,
        statistics: this.$CONFIG.statistics
      }
      let res = await this.$vipapi.getCounponDetail(params)
      if (res.status === 200) {
        this.info = res.data.data.info
        this.other = res.data.data.other
      }
      console.log(this.info, this.other)
    },
    // 领取优惠券
    getReceiveCoupon() {
      // 未登录
      if (!this.token) {
        this.phoneLogin()
      } else {
        let params = `actId=${this.actId}&token=${this.token}&statistics=${this.$CONFIG.statistics}`
        this.$vipapi.receiveCoupon(params).then((res) => {
          // 不满足条件
          if (res.data.status === '201') {
            // 20210803雪龙需求，不满足条件弹弹窗
            this.vipCouponDialogInfo = {
              num: res.data.data.vipList.length, // 1单个会员 >1多个会员
              vipList: res.data.data.vipList
            }
            this.changeCouponDialog(true)
            console.log(res.data.msg)
          } else {
            console.log(res.data.msg)
            this.title = '提示'
            this.infos = res.data.msg
            this.showDialog(true)
            // window.location.reload()
          }
        })
      }
    },
    // 显示优惠券不满足需开通会员弹窗
    changeCouponDialog(visible) {
      this.showCouponDialog = visible
    },
    handleOpenVip(id) {
      if (this.isIOS) {
        this.$router.push(
          `/vipiospay?id=${id}&fromh5=1&type=1&token=${this.token}`
        )
      } else {
        this.$router.push(
          `/vippay?id=${id}&fromh5=1&type=1&token=${this.token}`
        )
      }
    },
    // 两端的登录方法
    phoneLogin() {
      // 安卓登录
      try {
        window.LiveAppJS.login()
      } catch (e) {
        console.log('error')
      }
      // IOS登录
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login')
      } catch (e) {
        console.log('error')
      }
    },
    // 显示弹窗
    showDialog(visible) {
      this.dialogIsShow = visible
    },
    // 修改两端标题
    changeAppTitle(newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题', newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log('安卓修改标题', newtitle)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.vipCoupon {
  .couponMain {
    // width: 100%;
    height: 5.34rem;
    // padding: 0.2rem;
    margin: 0.2rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: url('https://images.zhibo.tv/2020/0514/coupon_bg_b.svg')
      no-repeat;
    background-size: 100%;

    .info {
      height: 3.3rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .couponName {
        display: flex;
        justify-content: center;
        align-items: baseline;
        font-size: 1.2rem;
        font-family: BebasNeue;
        color: #69410c;
        // 人民币符号
        .rmb {
          font-size: 0.5rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #69410c;
          margin-right: -0.15rem;
        }
        // 优惠券三个字
        .word {
          font-size: 0.36rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #69410c;
        }
      }
      .couponType {
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #69410c;
      }
    }
    .btn {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .redbtn {
        width: 6rem;
        height: 0.7rem;
        background: linear-gradient(135deg, #ff6945 0%, #ff4834 100%);
        border-radius: 0.35rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }
      .gbtn {
        background: #f7f7f7;
        color: #999999;
      }
    }
  }
  .other {
    margin: 0.3rem 0.3rem 0 0.3rem;
    padding: 0.2rem 0.2rem 0.3rem 0.2rem;
    background: #ffffff;
    box-shadow: 0 0.01rem 0.1rem 0 rgba(0, 0, 0, 0.1);
    .otherItem {
      margin-bottom: 0.4rem;
      // 标题
      .title {
        margin-bottom: 0.2rem;
        font-size: 0.34rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      // 内容
      .content {
        .contentItem {
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 0.4rem;
        }
      }
      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}
</style>
